// The wizard is a single integer `step`. Section letters follow the official
// form (A-J, L, K); the order below is the order the user walks through them:
// the review screen sits between the documents (L) and the signature (K).
export const STEP = {
	START: 0,
	A: 1,
	B: 2,
	C: 3,
	D: 4,
	E: 5,
	F: 6,
	G: 7,
	H: 8,
	I: 9,
	J: 10,
	L: 11,
	REVIEW: 12,
	K: 13,
	FINISH: 14,
}

// Entries of the progress bar, in order. ProgressBar treats the n-th entry as
// step n, so entry i must have step === i + 1 (checked in steps.test.js).
export const PROGRESS_STEPS = [
	{ step: STEP.A, label: 'A' },
	{ step: STEP.B, label: 'B' },
	{ step: STEP.C, label: 'C' },
	{ step: STEP.D, label: 'D' },
	{ step: STEP.E, label: 'E' },
	{ step: STEP.F, label: 'F' },
	{ step: STEP.G, label: 'G' },
	{ step: STEP.H, label: 'H' },
	{ step: STEP.I, label: 'I' },
	{ step: STEP.J, label: 'J' },
	{ step: STEP.L, label: 'L' },
	{ step: STEP.REVIEW, label: 'Ü' },
	{ step: STEP.K, label: 'K' },
]

// True while the user is inside the form proper (progress bar visible).
export const isFormStep = step => step > STEP.START && step < STEP.FINISH

// URL fragment for each step (`#/a`, `#/review`, ...), so the browser's Back and
// Forward buttons move through the wizard instead of leaving the app. Only used
// for navigation: the fragment never carries data.
export const STEP_SLUG = {
	[STEP.START]: 'start',
	[STEP.A]: 'a',
	[STEP.B]: 'b',
	[STEP.C]: 'c',
	[STEP.D]: 'd',
	[STEP.E]: 'e',
	[STEP.F]: 'f',
	[STEP.G]: 'g',
	[STEP.H]: 'h',
	[STEP.I]: 'i',
	[STEP.J]: 'j',
	[STEP.L]: 'l',
	[STEP.REVIEW]: 'review',
	[STEP.K]: 'k',
	[STEP.FINISH]: 'finish',
}

export const stepFromHash = hash => {
	const slug = String(hash || '').replace(/^#\/?/, '')
	const entry = Object.entries(STEP_SLUG).find(([, value]) => value === slug)
	return entry ? Number(entry[0]) : null
}

export const hashForStep = step => `#/${STEP_SLUG[step] ?? STEP_SLUG[STEP.START]}`
